import { JobHistoryLevel, JobHistoryStatus, JobHistoryType } from '@/common/graphql';

export const JobHistoryTypeLabels: Record<JobHistoryType, string> = {
  [JobHistoryType.PromotionDemotion]: 'Promotion / Demotion',
  [JobHistoryType.Transfer]: 'Transfer',
  [JobHistoryType.ParentalLeave]: 'Parental Leave',
  [JobHistoryType.ExtendedLeave]: 'Extended Leave',
  [JobHistoryType.ChangeWithoutPromotionDemotion]: 'Change Without Promotion / Demotion',
  [JobHistoryType.Join]: 'Join',
  [JobHistoryType.NewContract]: 'New Contract',
};

export const JobHistoryStatusLabels: Record<JobHistoryStatus, string> = {
  [JobHistoryStatus.Current]: 'Current',
  [JobHistoryStatus.Future]: 'Future',
  [JobHistoryStatus.Past]: 'Past',
};

export const JobHistoryLevelLabels: Record<JobHistoryLevel, string> = {
  [JobHistoryLevel.L0]: 'L0',
  [JobHistoryLevel.L1]: 'L1',
  [JobHistoryLevel.L2]: 'L2',
  [JobHistoryLevel.L3]: 'L3',
  [JobHistoryLevel.L4]: 'L4',
  [JobHistoryLevel.L5]: 'L5',
  [JobHistoryLevel.L6]: 'L6',
  [JobHistoryLevel.L7]: 'L7',
  [JobHistoryLevel.Ic3]: 'IC3',
  [JobHistoryLevel.Ic4]: 'IC4',
  [JobHistoryLevel.Ic5]: 'IC5',
  [JobHistoryLevel.Ic6]: 'IC6',
  [JobHistoryLevel.Ic7]: 'IC7',
  [JobHistoryLevel.CClass]: 'C-Class',
};
